(() => {
  function initializeAuctionMedia(root) {
    const mediaRoot = root.querySelector('[data-auction-media]');
    if (!mediaRoot) return;

    const mediaItems = [
      { type: 'image', src: mediaRoot.getAttribute('data-image-one') },
      { type: 'image', src: mediaRoot.getAttribute('data-image-two') },
      { type: 'image', src: mediaRoot.getAttribute('data-image-three') },
      { type: 'image', src: mediaRoot.getAttribute('data-image-four') },
      { type: 'video', src: mediaRoot.getAttribute('data-video-url') },
    ];

    const mainImage = mediaRoot.querySelector('[data-auction-main-image]');
    const mainVideoWrapper = mediaRoot.querySelector('[data-auction-main-video]');
    const mainVideoPlayer = mediaRoot.querySelector('[data-auction-main-video-player]');
    const thumbnailButtons = Array.from(mediaRoot.querySelectorAll('[data-auction-thumb]'));

    const openModalButton = mediaRoot.querySelector('[data-auction-enlarge]');
    const modal = mediaRoot.querySelector('[data-auction-modal]');
    const modalImage = mediaRoot.querySelector('[data-auction-modal-image]');
    const closeModalButton = mediaRoot.querySelector('[data-auction-close]');
    const modalZoomIn = mediaRoot.querySelector('[data-auction-modal-zoom-in]');
    const modalZoomOut = mediaRoot.querySelector('[data-auction-modal-zoom-out]');
    const modalZoomReset = mediaRoot.querySelector('[data-auction-modal-reset]');

    if ((!mainImage && !mainVideoWrapper) || mediaItems.every((item) => !item.src)) return;

    let currentIndex = 0;
    let zoomLevel = 1;

    function applyMedia(index) {
      const item = mediaItems[index];
      if (!item || !item.src) return;

      currentIndex = index;

      if (item.type === 'video') {
        if (openModalButton) openModalButton.hidden = true;
        if (mainVideoWrapper) mainVideoWrapper.hidden = false;
        if (mainVideoPlayer && mainVideoPlayer.src !== item.src) {
          mainVideoPlayer.src = item.src;
          mainVideoPlayer.load();
        }
      } else {
        if (openModalButton) openModalButton.hidden = false;
        if (mainVideoWrapper) mainVideoWrapper.hidden = true;
        if (mainVideoPlayer) {
          mainVideoPlayer.pause();
          mainVideoPlayer.removeAttribute('src');
          mainVideoPlayer.load();
        }
        if (mainImage) mainImage.src = item.src;
        if (modalImage) modalImage.src = item.src;
      }

      thumbnailButtons.forEach((button) => {
        const buttonIndex = Number(button.getAttribute('data-auction-thumb'));
        button.setAttribute('aria-pressed', String(buttonIndex === currentIndex));
      });
    }

    function applyZoom() {
      if (modalImage) modalImage.style.transform = `scale(${zoomLevel})`;
    }

    thumbnailButtons.forEach((button) => {
      button.addEventListener('click', () => {
        applyMedia(Number(button.getAttribute('data-auction-thumb')));
      });
    });

    if (openModalButton && modal) {
      openModalButton.addEventListener('click', () => {
        if (modal.showModal) modal.showModal();
        else modal.setAttribute('open', 'open');
      });
    }

    if (closeModalButton && modal) {
      const closeModal = () => {
        if (modal.close) modal.close();
        else modal.removeAttribute('open');
      };
      closeModalButton.addEventListener('click', closeModal);
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });
    }

    if (modalZoomIn) {
      modalZoomIn.addEventListener('click', () => {
        zoomLevel = Math.min(3, zoomLevel + 0.2);
        applyZoom();
      });
    }
    if (modalZoomOut) {
      modalZoomOut.addEventListener('click', () => {
        zoomLevel = Math.max(1, zoomLevel - 0.2);
        applyZoom();
      });
    }
    if (modalZoomReset) {
      modalZoomReset.addEventListener('click', () => {
        zoomLevel = 1;
        applyZoom();
      });
    }

    const firstAvailable = mediaItems.findIndex((item) => item.src);
    applyMedia(firstAvailable >= 0 ? firstAvailable : 0);
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function updateCountdown(root, remainingMs) {
    const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
    root.querySelector('[data-auction-days]').textContent = pad(Math.floor(totalSeconds / 86400));
    root.querySelector('[data-auction-hours]').textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
    root.querySelector('[data-auction-minutes]').textContent = pad(Math.floor((totalSeconds % 3600) / 60));
    root.querySelector('[data-auction-seconds]').textContent = pad(totalSeconds % 60);
  }

  function initializeAuction(root) {
    const card = root.querySelector('[data-auction-countdown]');
    if (!card) return;

    const endRaw = card.getAttribute('data-auction-end');
    const minimumBid = Number(card.getAttribute('data-auction-minimum')) || 0;
    const highestBid = Number(card.getAttribute('data-auction-highest')) || 0;
    const bidStep = Number(card.getAttribute('data-auction-step')) || 1;
    const threshold = highestBid > 0 ? highestBid + bidStep : Math.max(minimumBid, bidStep);

    const bidInput = root.querySelector('[data-auction-bid-input]');
    const hint = root.querySelector('[data-auction-hint]');
    const form = root.querySelector('[data-auction-form]');
    const submitButton = root.querySelector('[data-auction-submit]');
    const endedMessage = root.querySelector('[data-auction-ended-message]');
    const badgeLabel = root.querySelector('[data-auction-badge-label]');
    const endLabel = root.querySelector('[data-auction-end-label]');
    const quickBids = root.querySelector('[data-auction-quick-bids]');

    if (bidInput) {
      bidInput.min = String(threshold);
      bidInput.placeholder = `Mindst ${threshold} kr`;
    }

    if (hint) {
      hint.textContent = `Dit bud skal være mindst ${threshold} kr.`;
    }

    if (quickBids && bidInput) {
      [0, 25, 50].forEach((extra) => {
        const amount = threshold + extra;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kast-auction__quick-bid';
        button.textContent = `${amount} kr`;
        button.addEventListener('click', () => {
          bidInput.value = String(amount);
          bidInput.focus();
        });
        quickBids.appendChild(button);
      });
    }

    const endTimestamp = Date.parse(endRaw);
    if (Number.isNaN(endTimestamp)) {
      if (hint) hint.textContent = 'Auktionsslut er ikke sat korrekt op. Brug ISO-datoformat.';
      return;
    }

    if (endLabel) {
      const formatter = new Intl.DateTimeFormat('da-DK', {
        day: 'numeric',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit',
      });
      endLabel.textContent = `Slutter ${formatter.format(new Date(endTimestamp))}`;
    }

    const setEndedState = () => {
      card.setAttribute('data-ended', '');
      if (endedMessage) endedMessage.hidden = false;
      if (bidInput) bidInput.disabled = true;
      if (submitButton) submitButton.disabled = true;
      if (badgeLabel) badgeLabel.textContent = 'Afsluttet';
      if (endLabel) endLabel.textContent = '';
      if (quickBids) quickBids.querySelectorAll('button').forEach((button) => (button.disabled = true));
    };

    const tick = () => {
      const remaining = endTimestamp - Date.now();
      updateCountdown(root, remaining);

      if (remaining > 0 && remaining <= 86400000) {
        card.setAttribute('data-urgent', '');
      }

      if (remaining <= 0) {
        setEndedState();
        window.clearInterval(timer);
      }
    };

    const timer = window.setInterval(tick, 1000);
    tick();

    if (form) {
      form.addEventListener('submit', (event) => {
        const bidValue = Number(bidInput?.value || 0);
        if (!Number.isFinite(bidValue) || bidValue < threshold) {
          event.preventDefault();
          if (hint) hint.textContent = `Buddet er for lavt. Minimum er ${threshold} kr.`;
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-auction-root]').forEach((root) => {
      initializeAuctionMedia(root);
      initializeAuction(root);
    });
  });
})();
